"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDevelopment = exports.isPreProduction = exports.isProduction = exports.RELEASE_STAGES = void 0;
exports.RELEASE_STAGES = ['production', 'pre-production', 'development'];
function isProduction(releaseStage) {
    return releaseStage === 'production';
}
exports.isProduction = isProduction;
function isPreProduction(releaseStage) {
    return releaseStage === 'pre-production';
}
exports.isPreProduction = isPreProduction;
function isDevelopment(releaseStage) {
    // Development is the default value if not production or pre-production
    // This includes process.env.REACT_APP_RELEASE_STAGE being undefined
    return !isProduction(releaseStage) && !isPreProduction(releaseStage);
}
exports.isDevelopment = isDevelopment;
